var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94466 9.21581V8.13813L6.41836 8.13816V9.21585C6.41836 9.35716 6.30165 9.47376 6.16045 9.47376H0.784142C0.642831 9.47376 0.526234 9.35716 0.526234 9.21585V0.784221C0.526234 0.642909 0.642942 0.526311 0.784142 0.526311L6.16045 0.526275C6.30176 0.526275 6.41836 0.642873 6.41836 0.784185V1.86187H6.94466V0.784185C6.94466 0.352315 6.59228 0 6.16048 0H0.784179C0.352313 0 0 0.352278 0 0.784185V9.21581C0 9.64768 0.352387 10 0.784179 10H6.16048C6.59235 10 6.94466 9.64772 6.94466 9.21581ZM9.92706 4.81837L9.97804 4.89518L9.97803 4.89532C10.0222 4.99684 9.99787 5.10997 9.92272 5.18624L7.56141 7.54757L7.18925 7.17541L9.10135 5.2632H2.78543C2.439 5.2632 2.439 4.73689 2.78543 4.73689H9.10135L7.18925 2.82477L7.56141 2.45261L9.92706 4.81837Z",
    fill: "#485057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.ae2409cae9c59f06b7bf10e06259cdc1.svg";
export { ForwardRef as ReactComponent };